import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal, Button } from "react-bootstrap";

// Redux
import { connect } from "react-redux";
import * as actions from "../../redux/actions";

// Component
// import Icon from "../Icon";
// import Color from "../../assets/color";

class ModalProductPreference extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      preference: {
        Pork: false,
        Beef: false,
        Lamb: false,
        Seafood: false,
        Chicken: false,
        malayFriendly: false,
      },
    };
  }

  componentDidMount() {
    const { isFirstLoad } = this.props;
    let productPref = JSON.parse(
      window.localStorage.getItem("persist:ProductPref")
    );
    let proPref = JSON.parse(
      productPref && productPref.productPreference
        ? productPref.productPreference
        : {}
    );
    if (
      isFirstLoad === false &&
      JSON.stringify(proPref) === JSON.stringify({})
    ) {
      let param = {};
      let preference = this.state.preference;
      preference = JSON.stringify(preference);
      param.food_perf = preference;
      this.props.onSetProductPreference(param);
    }
  }

  componentDidUpdate(prevProps) {
    const { isFirstLoad } = this.props;
    if (isFirstLoad) {
      if (this.props.locationModalVisible === false) {
        this.setState(
          {
            visible: true,
          },
          () => {
            this.props.updateIsFirstLoad();
          }
        );
      }
    }

    if (prevProps.product_preference !== this.props.product_preference) {
      if (this.props.product_preference.success) {
        this.setState({
          visible: false,
        });
      }
    }
  }

  _onChangePreference = (type) => {
    let currentPreference = this.state.preference;

    currentPreference[type] = !currentPreference[type];

    this.setState({ preference: currentPreference });
  };

  _onSubmit = () => {
    this.setState(
      {
        visible: false,
      },
      () => {
        let param = {};
        let preference = this.state.preference;

        preference = JSON.stringify(preference);
        param.food_perf = preference;
        this.props.onSetProductPreference(param);
      }
    );
  };

  _hideModal = () => {
    this.setState({
      visible: false,
    });
  };

  render() {
    const { preference, visible } = this.state;

    return (
      <Modal
        size="xs"
        show={visible}
        onHide={this._hideModal}
        centered={true}
        className="modal-product-preference"
        backdrop="static"
      >
        <Modal.Header>
          <h3 className="title">Product Preference</h3>
        </Modal.Header>
        <div className="inner-container">
          {/* <div className="position-relative text-right">
            <div className="btn-close" onClick={this._hideModal}>
              <Icon
                type="custom"
                name="closecircle"
                color={Color.black}
                size={30}
              />
            </div>
          </div> */}
          {/* <h3>Product Preference</h3> */}
          <div className="preference">
            {Object.keys(preference).map((type, index) => (
              <div
                className={`preference-type clickable 
                ${preference[type] === true ? "active" : ""}
                `}
                key={index}
                onClick={() => this._onChangePreference(type)}
              >
                {/* {console.log(preference[type])} */}
                {type === "malayFriendly" ? (
                  <p>Muslim Friendly</p>
                ) : (
                  <p>No {type}</p>
                )}
              </div>
            ))}
          </div>
        </div>
        <Modal.Footer>
          <div className="d-flex">
            <Button
              variant="primary"
              className="ml-auto"
              onClick={() => this._onSubmit()}
            >
              Confirm
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

ModalProductPreference.propTypes = {
  product_preference: PropTypes.bool,
  onSetProductPreference: PropTypes.func.isRequired,
  locationModalVisible: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  return {
    isFirstLoad: state.IsFirstLoad.isFirstLoad,
    storeLocation: state.Location.storeLocation,
    product_preference: state.ProductPreference.product_preference,
    locationModalVisible: state.Location.locationModalVisible,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // Product Preference
    onSetProductPreference: (params) =>
      dispatch(actions.setProductPreference(params, false)),
    updateIsFirstLoad: () => dispatch(actions.updateIsFirstLoad()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalProductPreference);
